<template>
  <div class="Wdgt-Content-External" ref="parent">
    <div class="Wdgt-Content-External__item" v-for="(item, index) in props.post.embed_links" :key="index">
      <template v-for="link in get_link(item)">
        <template v-if="get_isTelegramLink(link)">
          <div class="Wdgt-Content-External__telegram-item">
            <TelegramItem class="Wdgt-Content-External__telegram-widget" :style="scaleStyle" :link="get_telegramParam(link)" />
          </div>
        </template>
        <template v-else-if="get_isYoutubeLink(link)">
          <template v-if="Object.values(item)[0]">
            <div class="Wdgt-Content-External__iframe" v-html="Object.values(item)[0]"></div>
          </template>
          <template v-else>
            <div class="Wdgt-Content-External__iframe">
              <iframe class=" video" width="670" height="377" :src="get_embedYoutubelink(get_link(item)[0])" frameborder="no" allow="accelerometer; gyroscope;" allowfullscreen="allowfullscreen"></iframe>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
  
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue';
  import { Props } from './scripts/props.js';
  import { throttle } from 'lodash';
  //----------------------------------------
  import TelegramItem from './components/TelegramItem/TelegramItem.vue';
  //----------------------------------------
  const props = defineProps(Props());
  //----------------------------------------
  const parent = ref(null);
  const scaleStyle = ref('');
  const maxHeightItem = ref('');
  //----------------------------------------
  onMounted(() => {
    updateScaleTelegram();
    window.addEventListener('resize', updateScaleTelegram);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScaleTelegram);
  });
  //----------------------------------------
  const get_link = (item) => { return Object.keys(item); };
  //Ссылка относится к телеграмму?
  const get_isTelegramLink = (link) => { return checkLinkType(link) === 'telegram'; }
  //Ссылка относится к ютубу?
  const get_isYoutubeLink = (link) => { return checkLinkType(link) === 'youtube'; }
  //Получить параметр для тг виджета
  const get_telegramParam = (link) => {
    const parsedUrl = new URL(link);
    const path = parsedUrl.pathname;
    return path.startsWith('/') ? path.slice(1) : path
  };
  //Сделать embed для youtube
  const get_embedYoutubelink = (link) => {
    if (link.includes('youtube.com/embed/')) return link;
    const match = link.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    const videoId = match[1];
    return `https://www.youtube.com/embed/${videoId}`;
  }
  //----------------------------------------
  //Определяем, к какому ресурсу относится сслыка
  const checkLinkType = (url) => {
    const youtubeDomains = ['youtube.com', 'youtu.be'];
    const telegramDomains = ['t.me'];
    const parsedUrl = new URL(url); 
    const hostname = parsedUrl.hostname.toLowerCase();
    if (youtubeDomains.some((domain) => hostname.includes(domain)))  return 'youtube';
    if (telegramDomains.some((domain) => hostname.includes(domain))) return 'telegram';
    return false;
  }
  //Масштабирование для виджета телеграмм поста
  const updateScaleTelegram = throttle(async () => {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 380) {
      const container = parent.value;
      const containerWidth = container ? container.offsetWidth : 1000;
      const scaleFactor = Math.min(containerWidth / 320, 1);
      scaleStyle.value = `transform: scale(${scaleFactor})`;
      await nextTick(async () => {
        const items = parent.value.querySelectorAll('.Wdgt-Content-External__telegram-item');
        if (!items.length) return;
        if (!maxHeightItem.value) {
          const firstItem = items[0];
          if (firstItem){ 
            maxHeightItem.value = firstItem.offsetHeight / scaleFactor; 
          }
        }
        items.forEach((item) => {
          if (maxHeightItem.value) {
            item.style.height = `${maxHeightItem.value * scaleFactor}px`;
          }
        });
      });
    } else {
      scaleStyle.value = '';
      maxHeightItem.value = null;
      const items = parent.value.querySelectorAll('.Wdgt-Content-External__telegram-item');
      items.forEach((item) => {
        item.style.height = '';
      });
    }
  }, 200)
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>